/**
 * LUMERA LANDING JS CONTROLLER
 * Synchronizes pack selection, physical quantity, pricing, sticky ATC, and UI accordions.
 */

document.addEventListener('DOMContentLoaded', () => {
  initLumeraPacks();
  initLumeraGallery();
  initLumeraFaq();
  initLumeraStickyAtc();
  initLumeraTrustSlider();
  initLumeraAddToCartForms();
  initLumeraAnchorScroll();
});

// Global state for active pack (Base product: 10m variant with quantity scaling)
window.LumeraState = {
  activePack: '20m',
  variantId: '50489849184497', // 10 Metros base product
  quantity: 2,                  // 2 units = 20 metros
  price: '$34.990',
  title: '20 METROS (2 Guirnaldas)'
};

function initLumeraPacks() {
  const packCards = document.querySelectorAll('.lumera-pack-card');
  if (!packCards.length) return;

  const BASE_VARIANT_ID = '50489849184497';

  // Function to sync all pack UI & forms across the page
  function updateGlobalPack(packValue, quantity, price, packTitle, variantId) {
    const finalVariantId = variantId || BASE_VARIANT_ID;
    const finalQty = parseInt(quantity, 10) || 1;

    window.LumeraState.activePack = packValue;
    window.LumeraState.variantId = finalVariantId;
    window.LumeraState.quantity = finalQty;
    window.LumeraState.price = price;
    window.LumeraState.title = packTitle;

    // 1. Update all pack cards visually & radio checked state
    document.querySelectorAll('.lumera-pack-card').forEach((card) => {
      const val = card.getAttribute('data-pack-value');
      const radio = card.querySelector('input[type="radio"]');
      if (val === packValue) {
        card.classList.add('is-selected');
        if (radio) radio.checked = true;
      } else {
        card.classList.remove('is-selected');
        if (radio) radio.checked = false;
      }
    });

    // 2. Update ALL variant id inputs in ALL forms on the page
    document.querySelectorAll('input[name="id"]').forEach((input) => {
      input.value = finalVariantId;
    });

    // 3. Update ALL quantity inputs in ALL forms on the page
    document.querySelectorAll('input[name="quantity"]').forEach((input) => {
      input.value = finalQty;
    });

    // 4. Update Sticky ATC price & label
    const stickyPriceEl = document.querySelector('.lumera-sticky-price');
    if (stickyPriceEl) {
      stickyPriceEl.textContent = price;
    }

    const stickyTitleEl = document.querySelector('.lumera-sticky-desc');
    if (stickyTitleEl) {
      stickyTitleEl.textContent = packTitle;
    }

    // 5. Dispatch custom event
    document.dispatchEvent(new CustomEvent('lumera:pack-change', {
      detail: { packValue, quantity: finalQty, price, packTitle, variantId: finalVariantId }
    }));
  }

  // Delegate click event on pack cards
  document.addEventListener('click', (e) => {
    const card = e.target.closest('.lumera-pack-card');
    if (!card) return;

    const packValue = card.getAttribute('data-pack-value') || '20m';
    const variantId = card.getAttribute('data-variant-id') || BASE_VARIANT_ID;
    const quantity = parseInt(card.getAttribute('data-pack-qty') || '2', 10);
    const price = card.getAttribute('data-pack-price') || '$34.990';
    const title = card.querySelector('.lumera-pack-title')?.textContent?.trim() || 'Pack Lumera';

    updateGlobalPack(packValue, quantity, price, title, variantId);
  });

  // Initialize with default Pack 2 (20m)
  const defaultCard = document.querySelector('.lumera-pack-card[data-pack-value="20m"]');
  const defaultVariantId = defaultCard ? defaultCard.getAttribute('data-variant-id') : BASE_VARIANT_ID;
  updateGlobalPack('20m', 2, '$34.990', '20 METROS (2 Guirnaldas)', defaultVariantId);
}

function initLumeraGallery() {
  const slider = document.querySelector('.lumera-gallery-slider');
  const slides = document.querySelectorAll('.lumera-gallery-slide');
  const thumbs = document.querySelectorAll('.lumera-thumb-item');
  const dots = document.querySelectorAll('.lumera-gallery-dot');
  const mainImage = document.querySelector('.lumera-gallery-main img');

  // Fallback for single static main image
  if (thumbs.length && mainImage && !slider) {
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const fullSrc = thumb.getAttribute('data-full-src');
        if (fullSrc) mainImage.src = fullSrc;
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
    return;
  }

  if (!slider || !slides.length) return;

  function setActive(index) {
    slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
    thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
    dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
  }

  // Sync active indicators during swipe scroll
  let isScrolling = false;
  slider.addEventListener('scroll', () => {
    if (!isScrolling) {
      window.requestAnimationFrame(() => {
        const slideWidth = slider.clientWidth;
        if (slideWidth > 0) {
          const index = Math.round(slider.scrollLeft / slideWidth);
          setActive(index);
        }
        isScrolling = false;
      });
      isScrolling = true;
    }
  }, { passive: true });

  // Thumbnail clicks
  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => {
      const slideWidth = slider.clientWidth;
      slider.scrollTo({ left: slideWidth * i, behavior: 'smooth' });
      setActive(i);
    });
  });

  // Dot clicks
  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      const slideWidth = slider.clientWidth;
      slider.scrollTo({ left: slideWidth * i, behavior: 'smooth' });
      setActive(i);
    });
  });
}

function initLumeraFaq() {
  const triggers = document.querySelectorAll('.lumera-faq-trigger');
  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      const content = trigger.nextElementSibling;

      trigger.setAttribute('aria-expanded', !expanded);
      if (content) {
        content.hidden = expanded;
      }
    });
  });
}

function initLumeraStickyAtc() {
  const stickyAtc = document.querySelector('.lumera-sticky-atc');
  const heroCta = document.querySelector('.lumera-hero-cta-trigger');

  if (!stickyAtc || !heroCta) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      // Show sticky ATC when user scrolls past hero CTA
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        stickyAtc.classList.add('is-visible');
      } else {
        stickyAtc.classList.remove('is-visible');
      }
    });
  }, { threshold: 0.1 });

  observer.observe(heroCta);
}

function initLumeraTrustSlider() {
  const slider = document.querySelector('.lumera-trust-slider');
  const slides = document.querySelectorAll('.lumera-trust-slide');
  const dots = document.querySelectorAll('.lumera-trust-dot');

  if (!slider || !slides.length) return;

  function setActive(index) {
    slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
    dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
  }

  // Scroll listener to update dots during swipe
  let isScrolling = false;
  slider.addEventListener('scroll', () => {
    if (!isScrolling) {
      window.requestAnimationFrame(() => {
        const slideWidth = slides[0]?.offsetWidth || slider.clientWidth * 0.82;
        const gap = 14;
        if (slideWidth > 0) {
          const index = Math.round(slider.scrollLeft / (slideWidth + gap));
          setActive(Math.min(Math.max(index, 0), slides.length - 1));
        }
        isScrolling = false;
      });
      isScrolling = true;
    }
  }, { passive: true });

  // Dots click navigation
  dots.forEach((dot, i) => {
    dot.addEventListener('click', (e) => {
      e.preventDefault();
      const slideWidth = slides[0]?.offsetWidth || slider.clientWidth * 0.82;
      const gap = 14;
      slider.scrollTo({ left: (slideWidth + gap) * i, behavior: 'smooth' });
      setActive(i);
    });
  });

  // Touch & Mouse Drag Controller (Ensures dragging works everywhere)
  let isDown = false;
  let startX = 0;
  let scrollLeft = 0;

  const startDrag = (e) => {
    isDown = true;
    slider.classList.add('is-dragging');
    const pageX = e.touches ? e.touches[0].pageX : e.pageX;
    startX = pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  };

  const stopDrag = () => {
    if (!isDown) return;
    isDown = false;
    slider.classList.remove('is-dragging');
    const slideWidth = slides[0]?.offsetWidth || slider.clientWidth * 0.82;
    const gap = 14;
    const index = Math.round(slider.scrollLeft / (slideWidth + gap));
    slider.scrollTo({ left: (slideWidth + gap) * index, behavior: 'smooth' });
  };

  const moveDrag = (e) => {
    if (!isDown) return;
    const pageX = e.touches ? e.touches[0].pageX : e.pageX;
    const x = pageX - slider.offsetLeft;
    const walk = (x - startX) * 1.5;
    slider.scrollLeft = scrollLeft - walk;
  };

  slider.addEventListener('mousedown', startDrag);
  slider.addEventListener('mouseleave', stopDrag);
  slider.addEventListener('mouseup', stopDrag);
  slider.addEventListener('mousemove', moveDrag);

  slider.addEventListener('touchstart', startDrag, { passive: true });
  slider.addEventListener('touchend', stopDrag, { passive: true });
  slider.addEventListener('touchmove', moveDrag, { passive: true });
}

function initLumeraAddToCartForms() {
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();

    const submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
    }

    try {
      // 1. Prepare form data and ensure variant ID & quantity are set correctly
      const formData = new FormData(form);
      const BASE_10M_ID = '50489849184497';
      const variantInput = form.querySelector('input[name="id"]');
      const variantId = variantInput?.value || window.LumeraState?.variantId || BASE_10M_ID;
      const targetQty = window.LumeraState?.quantity || parseInt(form.querySelector('input[name="quantity"]')?.value || '1', 10);
      formData.set('id', variantId);
      formData.set('quantity', targetQty.toString());
      formData.set('sections', 'cart-drawer,cart-icon-bubble');

      // 2. Clear cart first to prevent mixing multiple incompatible packs
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      // 3. Add selected pack to cart
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!addRes.ok) {
        const errJson = await addRes.json();
        throw new Error(errJson.description || errJson.message || 'Error al agregar al carrito');
      }

      const itemData = await addRes.json();

      // 4. Fetch fresh cart-drawer and cart-icon-bubble rendered HTML sections if not in response
      let sectionsData = itemData.sections || {};
      if (!sectionsData['cart-drawer']) {
        const sectionsUrl = `${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`;
        const secRes = await fetch(sectionsUrl, {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        if (secRes.ok) {
          sectionsData = await secRes.json();
        }
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        if (sectionsData['cart-drawer']) {
          // Render drawer contents using theme native method if available
          if (typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents({
              id: itemData.id,
              sections: sectionsData
            });
          } else {
            // Manual DOM injection fallback
            const parsed = new DOMParser().parseFromString(sectionsData['cart-drawer'], 'text/html');
            const newDrawer = parsed.querySelector('#CartDrawer');
            const oldDrawer = document.querySelector('#CartDrawer');
            if (newDrawer && oldDrawer) {
              oldDrawer.innerHTML = newDrawer.innerHTML;
            }
          }
        }

        // Open cart drawer
        cartDrawer.classList.remove('is-empty');
        const inner = cartDrawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');

        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          cartDrawer.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
        }

        // Ensure active classes persist
        setTimeout(() => {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
        }, 50);

        // Update header cart icon count bubble
        if (sectionsData['cart-icon-bubble']) {
          const parsedBubble = new DOMParser().parseFromString(sectionsData['cart-icon-bubble'], 'text/html');
          const newBubble = parsedBubble.querySelector('#cart-icon-bubble') || parsedBubble.body;
          const oldBubble = document.querySelector('#cart-icon-bubble');
          if (newBubble && oldBubble) {
            oldBubble.innerHTML = newBubble.innerHTML;
          }
        }
      } else {
        // Fallback to /cart if no drawer element exists
        window.location.href = '/cart';
      }

      // Dispatch global cart events
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: itemData } }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (err) {
      console.error('Error adding to cart:', err);
      alert('Hubo un problema al agregar el producto al carrito. Por favor intenta nuevamente.');
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.classList.remove('is-loading');
      }
    }
  });
}

function initLumeraAnchorScroll() {
  function scrollToTarget(targetId) {
    if (!targetId) return false;
    const cleanId = targetId.replace(/^#/, '');
    const target = document.getElementById(cleanId) || document.querySelector(`[name="${cleanId}"]`) || document.querySelector(`.${cleanId}`);
    if (target) {
      const header = document.querySelector('.lumera-header-wrapper') || document.querySelector('sticky-header') || document.querySelector('.section-header');
      const headerOffset = header ? (header.offsetHeight || 70) + 12 : 75;
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: Math.max(0, offsetPosition),
        behavior: 'smooth'
      });
      return true;
    }
    return false;
  }

  // Handle in-page clicks on any anchor link
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href*="#"]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || href === '#' || href === '#!') return;

    try {
      const url = new URL(link.href, window.location.href);
      // If the link points to the current page with a hash
      if (url.pathname.replace(/\/+$/, '') === window.location.pathname.replace(/\/+$/, '') && url.hash) {
        // Close hamburger menu drawer if open
        const drawer = document.getElementById('LumeraMenuDrawerDetails');
        if (drawer) {
          drawer.removeAttribute('open');
        }

        if (scrollToTarget(url.hash)) {
          e.preventDefault();
          if (history.pushState) {
            history.pushState(null, '', url.hash);
          }
        }
      }
    } catch (err) {
      // Fallback for simple local hashes
      if (href.startsWith('#')) {
        const drawer = document.getElementById('LumeraMenuDrawerDetails');
        if (drawer) drawer.removeAttribute('open');
        if (scrollToTarget(href)) {
          e.preventDefault();
        }
      }
    }
  });

  // Handle URL hash on initial page load
  if (window.location.hash) {
    setTimeout(() => {
      scrollToTarget(window.location.hash);
    }, 250);
  }
}



